<template>
<div class="main-body">
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Scan To Create RMA products
                  </h4>
              </div><!--col-->
          </div><!--row-->
          <hr />
          <rma-scan-item :fetchRmaLatestProducts="searchRmaLatestProducts"></rma-scan-item>
          <h4 class="mt-3">
            Latest RMA products
          </h4>
          <div class="row mt-2">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="10%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>{{ $t('marketplace.rma_product.document_no') }}</th>
                            <th>{{ $t('marketplace.rma_product.platform') }}</th>
                            <th>{{ $t('marketplace.rma_product.platform_order_id') }}</th>
                            <th>{{ $t('marketplace.rma_product.order_item_id') }}</th>
                            <th>{{ $t('marketplace.rma_product.imei_code') }}</th>
                            <th>{{ $t('marketplace.rma_product.product_name') }}</th>
                            <th>{{ $t('marketplace.rma_product.qty') }}</th>
                            <th>{{ $t('marketplace.rma_product.conditions') }}</th>
                            <th>{{ $t('marketplace.rma_product.cost') }}</th>
                            <!-- <th>{{ $t('marketplace.rma_product.selling_price') }}</th>
                            <th>{{ $t('marketplace.rma_product.deal_price') }}</th>
                            <th>{{ $t('marketplace.rma_product.sold_date') }}</th> -->
                            <th>{{ $t('marketplace.rma_product.status') }}</th>
                            <th>{{ $t('marketplace.rma_product.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(rmaProduct, index) in latestRmaProducts" :key="index">
                            <td>{{ rmaProduct.document_no }}</td>
                            <td>{{ rmaProduct.platform }}</td>
                            <td>{{ rmaProduct.platform_order_id }}</td>
                            <td>{{ rmaProduct.order_item_id }}</td>
                            <td>{{ rmaProduct.imei_code }}</td>
                            <td>{{ rmaProduct.product_name }}</td>
                            <td>{{ rmaProduct.qty }}</td>
                            <td>{{ rmaProduct.conditions }}</td>
                            <td>{{ rmaProduct.cost }}</td>
                            <td v-html="rmaProduct.status_label"></td>
                            <td>
                              <div v-if="rmaProduct.action_buttons && rmaProduct.action_buttons.editButton">
                                <router-link :to="{ path: '/rma-product/' + rmaProduct.id + '/edit' }">
                                  <b-button variant="primary btn-sm ml-1"><i class="fa fa-pencil"></i></b-button>
                                </router-link>
                              </div>
                               <!-- <b-button variant="danger btn-sm ml-1" @click.stop.prevent="handleDelete(rmaProduct.id)"><i class="fa fa-trash"></i></b-button> -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
  <loading-panel v-if="showLoadingPanel"></loading-panel>
</div>
</template>

<script>
import RmaScanItem from '@/views/components/marketplace/rma_product/RmaScanItem'
import LoadingPanel from '@/components/LoadingPanel'

export default {
  name: 'CreateRmaProduct',
  components: {
    RmaScanItem,
    LoadingPanel
  },
  data () {
    return {
      latestRmaProducts: [],
      showLoadingPanel: false
    }
  },
  methods: {
    searchRmaLatestProducts(params){
      console.log("param", params);
      this.axios.get('/marketplace/rma-product', {
        params
      }).then(response => {
        this.latestRmaProducts = response.data
      }).catch(error => {
        console.log(error)
      })
    },
    handleDelete (rmaProductId) {
      this.$swal({
        title: this.$t('operation.delete.title'),
        text: this.$t('operation.delete.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.delete.confirm_button')
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.delete('/marketplace/rma-product/' + rmaProductId).then(() => {
            // this.showLoadingPanel = false
            // this.$router.push('/marketplace/store')
            location.reload()
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
